// extracted by mini-css-extract-plugin
module.exports = {"blocksWrapper":"_3yarel2P","marginWrapper":"_11zUbRf6"};